/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import Stack from '@mui/material/Stack';
import { useState } from 'react';
import ButtonPrimary from 'components/Buttons/ButtonPrimary/ButtomPrimary.component';
import TextInputField from 'components/inputs/TextField/TextField.component';
import { FormGlobal } from 'styles/Global.styles';
import { maskInput, useScreenSize } from 'utils/helpers';
import { maskCpfCnpj } from 'utils/maskCpfCnpj';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { TableCadastroProps } from '@typings/componentables';
import { useApi } from 'hooks/userApi';
import { LoadingContext } from 'context/Loading/LoadingContext';
import { FormCategoria, FormVendedor } from '@typings/cadastro';
import ButtonSecondary from 'components/Buttons/ButtonSecondary/ButtonSecondary.component';
import ButtonTerciary from 'components/Buttons/ButtonTerciary/ButtonTerciary.component';

const api = useApi();

type TEditProps = {
  setEdit: () => void;
  dado: any;
};

const EditFormasPagamento = ({ setEdit, dado }: TEditProps) => {
  const [active, setSalvar] = useState(false);

  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
    clearLoading,
    setClearLoading,
  }: any = React.useContext(LoadingContext);

  const isBreak = useScreenSize(570);
  const schema = z.object({
    nome: z.string().nonempty({ message: 'Forma de pagamento é obrigatória' }),
  });

  const { clearErrors, handleSubmit, setValue, formState, watch } = useForm({
    defaultValues: {
      nome: dado.nome || '',
    },
    resolver: zodResolver(schema),
  });

  const dadosForm = [{ label: 'Forma  de pagamento', type: 'textarea', campo: 'nome', select: false, option: [] }];

  const onSubmit = async (data) => {
    setLoading(true);
    const arrReq = {
      nome: watch('nome'),
    };
    try {
      const msg = 'Atualizado com sucesso!';
      await api
        .patch(`/pagamento/${dado.id}`, arrReq)
        .then((response) => (setLoadingMensagem(msg), setLoadingBtn('OK'), window.location.reload()))
        .catch((err) => {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const msg_ = 'Houve um erro interno, tente mais tarde. ' + err.message;
          setLoadingMensagem(msg_);
          setLoadingBtn('OK');
        });
    } catch (e) {
      let msg = 'Houve um erro interno, tente mais tarde. ' + e.message;
      if (e.response.data.message === 'Unauthorized') {
        msg = 'Usuário não autorizado';
        setLoadingAction('/admin/sair');
      }

      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  function handleChange(name: FormCategoria, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const value = event.target.value;

    setValue(name, value);

    if (formState.errors[`${name}`]) {
      clearErrors(name);
    }
  }

  const isCampoInFormCliente = (campo: string): campo is FormCategoria => {
    return campo === 'nome';
  };

  return (
    <Stack spacing={2}>
      <FormGlobal noValidate onSubmit={handleSubmit(onSubmit)}>
        {dadosForm &&
          dadosForm.map((dados, index) => (
            <>
              <TextInputField
                key={index}
                label={dados.label}
                type={dados.type}
                selected={dados.select}
                nome={dados.campo}
                dados={dados.option}
                mask={maskInput(dados.campo)}
                style={{ width: isBreak ? '100%' : '49%' }}
                defaultValueText={'-- Selecione --'}
                value={isCampoInFormCliente(dados.campo) ? watch(dados.campo) : null}
                error={!!formState.errors[dados.campo]}
                helperText={formState.errors[dados.campo] ? formState.errors[dados.campo].message : ''}
                onChange={(nome) => (isCampoInFormCliente(dados.campo) ? handleChange(dados.campo, nome) : null)}
              />
            </>
          ))}
      </FormGlobal>
      <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center' }}>
        <ButtonPrimary onClick={handleSubmit(onSubmit)} typeSubmit={false} label={'Atualizar cadastro'} />
      </div>
      <ButtonTerciary onClick={setEdit} label={'Cancelar'} typeSubmit={false} />
    </Stack>
  );
};
export default EditFormasPagamento;
